(function(){
  if(window.__aksInit)return;window.__aksInit=true;
  var $=function(s,r){return (r||document).querySelector(s)};
  var $$=function(s,r){return [].slice.call((r||document).querySelectorAll(s))};

  /* Menú lateral */
  function drawer(open){
    var d=$('#AksDrawer');if(!d)return false;
    d.classList.toggle('is-open',open);d.setAttribute('aria-hidden',open?'false':'true');
    document.documentElement.classList.toggle('aks-lock',open);
    return true;
  }
  document.addEventListener('click',function(e){
    if(e.target.closest('[data-aks-open]')){e.preventDefault();drawer(true);return}
    if(e.target.closest('[data-aks-close]')){e.preventDefault();drawer(false);return}
    var st=e.target.closest('[data-aks-search]');
    if(st){var h=$('.aks-header');if(h){h.classList.toggle('is-search');var i=$('.aks-search__input',h);if(h.classList.contains('is-search')&&i)setTimeout(function(){i.focus()},50)}return}
    var cats=e.target.closest('[data-aks-cats]');
    if(cats&&drawer(true)){e.preventDefault();return}
  });
  document.addEventListener('keydown',function(e){if(e.key==='Escape')drawer(false)});

  /* Agregar al carrito desde tarjetas */
  function updateBubble(html){
    var b=$('#cart-icon-bubble');if(b&&html){var tmp=document.createElement('div');tmp.innerHTML=html;var src=tmp.querySelector('.shopify-section')||tmp;b.innerHTML=src.innerHTML}
  }
  function updateCount(n){$$('.akh-bnav__count').forEach(function(c){c.textContent=n});
    if(n>0&&!$('.akh-bnav__count')){var a=$('.akh-bnav a[href*="/cart"]');if(a){var s=document.createElement('span');s.className='akh-bnav__count';s.textContent=n;a.appendChild(s)}}}
  function syncMobileCount(){
    var bubble=$('#cart-icon-bubble .cart-count-bubble span[aria-hidden="true"]');
    var n=bubble?parseInt(bubble.textContent,10):0;
    if(Number.isFinite(n))updateCount(n);
  }
  function watchCartCount(){
    var bubble=$('#cart-icon-bubble');if(!bubble)return;
    new MutationObserver(syncMobileCount).observe(bubble,{childList:true,subtree:true,characterData:true});
    syncMobileCount();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',watchCartCount);else watchCartCount();
  document.addEventListener('click',function(e){
    var btn=e.target.closest('[data-ak-add]');if(!btn)return;
    e.preventDefault();if(btn.classList.contains('is-busy'))return;
    var input=btn.closest('.akh-card')?.querySelector('[data-ak-card-quantity]');
    if(input&&!input.reportValidity())return;
    var qty=input?Number(input.value):1;if(!Number.isSafeInteger(qty)||qty<1)return;
    var error=btn.closest('.akh-card')?.querySelector('.akh-card-error');if(error)error.textContent='';
    var label=btn.textContent;btn.classList.add('is-busy');btn.disabled=true;btn.textContent=btn.dataset.adding||'Agregando…';
    fetch((window.Shopify&&Shopify.routes?Shopify.routes.root:'/')+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify({items:[{id:parseInt(btn.dataset.akAdd,10),quantity:qty}],sections:['cart-icon-bubble','cart-drawer'],sections_url:location.pathname})})
      .then(function(r){return r.json().then(function(j){return {ok:r.ok,j:j}})})
      .then(function(res){
        if(!res.ok)throw Error(res.j?.description||btn.dataset.error);
        btn.classList.add('is-done');btn.textContent='✓ '+(btn.dataset.added||'Agregado');
        if(res.j.sections)updateBubble(res.j.sections['cart-icon-bubble']);var drawer=document.querySelector('cart-drawer');if(drawer&&res.j.sections?.['cart-drawer']){drawer.setActiveElement(btn);drawer.renderContents(res.j);}
        if(typeof publish==='function'&&typeof PUB_SUB_EVENTS!=='undefined')publish(PUB_SUB_EVENTS.cartUpdate,{source:'ak-card'});
        fetch((window.Shopify?.routes?.root||'/')+'cart.js').then(function(r){return r.json()}).then(function(c){updateCount(c.item_count)}).catch(function(){});
      })
      .catch(function(err){if(error)error.textContent=err.message||btn.dataset.error;btn.textContent=label;})
      .finally(function(){btn.classList.remove('is-busy');btn.disabled=false;setTimeout(function(){btn.classList.remove('is-done');btn.textContent=label},1800);});
  });

  /* Pestañas */
  document.addEventListener('click',function(e){
    var t=e.target.closest('.akt-tab');if(!t)return;
    var root=t.closest('[data-akt]');if(!root)return;
    $$('.akt-tab',root).forEach(function(x){var on=x===t;x.classList.toggle('is-active',on);x.setAttribute('aria-selected',on)});
    $$('.akt-panel',root).forEach(function(p){p.hidden=p.dataset.panel!==t.dataset.panel});
    t.scrollIntoView({block:'nearest',inline:'center',behavior:'smooth'});
  });

  /* Filtros de categoría: enviar al marcar */
  document.addEventListener('change',function(e){
    var f=e.target.closest('form[data-akcol-filter]');
    if(f&&e.target.type==='checkbox')f.submit();
  });
  document.addEventListener('click',function(e){
    var t=e.target.closest('.akcol-filters-toggle');if(t){t.closest('.akcol-side').classList.toggle('is-open')}
  });

  /* Cargar más */
  document.addEventListener('click',function(e){
    var b=e.target.closest('[data-akcol-more]');if(!b)return;
    var url=b.dataset.next;if(!url)return;
    b.disabled=true;var old=b.textContent;b.textContent='Cargando…';
    var sep=url.indexOf('?')>-1?'&':'?';
    fetch(url+sep+'section_id='+b.dataset.section).then(function(r){return r.text()}).then(function(html){
      var doc=new DOMParser().parseFromString(html,'text/html');
      var grid=$('[data-akcol-grid]'),ng=$('[data-akcol-grid]',doc);
      if(grid&&ng){$$(':scope > *',ng).forEach(function(n){grid.appendChild(n)})}
      var nb=$('[data-akcol-more]',doc),cur=$('.akcol-more');
      var ncur=$('.akcol-more',doc);
      if(cur&&ncur){cur.innerHTML=ncur.innerHTML}else if(cur&&!nb){cur.remove()}
      try{history.replaceState(null,'',url)}catch(err){}
    }).catch(function(){b.disabled=false;b.textContent=old});
  });

  /* Barra inferior y menú fuera del encabezado fijo */
  function bnav(){
    if($('.akh-bnav'))document.body.classList.add('akh-has-bnav');
    var d=$('#AksDrawer');if(d&&d.parentElement!==document.body)document.body.appendChild(d);
  }
  if(document.readyState!=='loading')bnav();else document.addEventListener('DOMContentLoaded',bnav);

  function belowMinimum(button) {
    const scope=button.closest('#main-cart-footer,.drawer__footer');
    const minimum=scope?.querySelector('[data-ak-minimum]');
    return minimum && Number(minimum.dataset.total)<10000000;
  }
  function enforceMinimum() {
    document.querySelectorAll('button[name="checkout"]').forEach(button=>{
      if(belowMinimum(button)&&!button.disabled)button.disabled=true;
    });
  }
  function initMinimum() {
    enforceMinimum();
    new MutationObserver(enforceMinimum).observe(document.body,{subtree:true,childList:true,attributes:true,attributeFilter:['disabled','data-total']});
    document.addEventListener('click',event=>{
      const button=event.target.closest('button[name="checkout"]');
      if(button&&belowMinimum(button)){event.preventDefault();event.stopImmediatePropagation();enforceMinimum();}
    },true);
    document.addEventListener('submit',event=>{
      const blocked=[...document.querySelectorAll('button[name="checkout"]')].some(button=>button.form===event.target&&belowMinimum(button));
      if(blocked){event.preventDefault();event.stopImmediatePropagation();enforceMinimum();}
    },true);
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',initMinimum);else initMinimum();

})();
